import type { CSSProperties, ReactNode } from "react";
import { T } from "../tokens";

export interface MonoLabelProps {
  children: ReactNode;
  color?: string;
  size?: number;
  style?: CSSProperties;
}

// Day 13 mobile readability guideline: never call this with size < 11 — the
// label becomes unreadable on iPhone Safari (375px wide) under strong sunlight.
// Atoms used to dev-warn on size < 11 but moved to docs to keep @goodbye/ui
// independent of Vite's import.meta.env.
export function MonoLabel({
  children,
  color = T.ink350,
  size = 13,
  style,
}: MonoLabelProps) {
  return (
    <span
      style={{
        fontFamily: T.mono,
        fontSize: size,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        color,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
